import moment from 'moment';
import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../../../redux/configureStore';
import { setInitialDateOption } from '../../../../../../../../../../redux/fetchActions/legadoPage/transferApp';

function SetInitialDate() {
  const dispatch = useDispatch();
  const transferssFilterState = useSelector(
    (reducer: IReducer) => reducer.transfersFilterApp
  );

  function setDate(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setInitialDateOption(value));
  }

  return (
    <Form.Control
      type="date"
      value={moment(transferssFilterState.dateFrom).format('YYYY-MM-DD')}
      onChange={(event) => setDate(event)}
    />
  );
}

export default SetInitialDate;
